/* eslint-disable @typescript-eslint/no-require-imports */
/**
 * Static web asset sources for every illustration file. webpack (apps/web via
 * Next) and Vite only emit an asset the bundler can see statically, so — like
 * the Metro map in sources.native.ts — every shipped file gets a literal
 * require() here. `resolveAssetModule` normalises the per-bundler module
 * shape (string URL, CommonJS default, or Next's static-image object) to the
 * URL the <img> needs.
 *
 * Generated by scripts/generate-illustration-sources.mjs — do not hand-edit.
 */

import { resolveAssetModule } from '../../elements/illustrations/resolveAssetModule';

export const characterIllustrationSources: Record<string, string> = {
  'ai-conversation.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/ai-conversation.colour.svg'),
  ),
  'ai-conversation.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/ai-conversation.mono.svg'),
  ),
  'being-active.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/being-active.colour.svg'),
  ),
  'being-active.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/being-active.mono.svg'),
  ),
  'breathalyser.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/breathalyser.colour.svg'),
  ),
  'breathalyser.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/breathalyser.mono.svg'),
  ),
  'care-team-at-work-emotional.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/care-team-at-work-emotional.colour.svg'),
  ),
  'care-team-at-work-emotional.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/care-team-at-work-emotional.mono.svg'),
  ),
  'care-team-at-work-functional.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/care-team-at-work-functional.colour.svg'),
  ),
  'care-team-at-work-functional.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/care-team-at-work-functional.mono.svg'),
  ),
  'carrying-boat.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/carrying-boat.colour.svg'),
  ),
  'carrying-boat.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/carrying-boat.mono.svg'),
  ),
  'character-a.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/character-a.colour.svg'),
  ),
  'character-a.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/character-a.mono.svg'),
  ),
  'character-b.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/character-b.colour.svg'),
  ),
  'character-b.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/character-b.mono.svg'),
  ),
  'character-c.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/character-c.colour.svg'),
  ),
  'character-c.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/character-c.mono.svg'),
  ),
  'character-d.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/character-d.colour.svg'),
  ),
  'character-d.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/character-d.mono.svg'),
  ),
  'cyclist.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/cyclist.colour.svg'),
  ),
  'cyclist.mono.svg': resolveAssetModule(require('../../../assets/illustrations/cyclist.mono.svg')),
  'exploring.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/exploring.colour.svg'),
  ),
  'exploring.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/exploring.mono.svg'),
  ),
  'family.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/family.colour.svg'),
  ),
  'family.mono.svg': resolveAssetModule(require('../../../assets/illustrations/family.mono.svg')),
  'feeling-support.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/feeling-support.colour.svg'),
  ),
  'feeling-support.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/feeling-support.mono.svg'),
  ),
  'fireworks.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/fireworks.colour.svg'),
  ),
  'fireworks.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/fireworks.mono.svg'),
  ),
  'friends-celebration.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/friends-celebration.colour.svg'),
  ),
  'friends-celebration.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/friends-celebration.mono.svg'),
  ),
  'getting-started-beach.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/getting-started-beach.colour.svg'),
  ),
  'getting-started-beach.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/getting-started-beach.mono.svg'),
  ),
  'getting-started-boat.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/getting-started-boat.colour.svg'),
  ),
  'getting-started-boat.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/getting-started-boat.mono.svg'),
  ),
  'growth-lg.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/growth-lg.colour.svg'),
  ),
  'growth-lg.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/growth-lg.mono.svg'),
  ),
  'growth-sm.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/growth-sm.colour.svg'),
  ),
  'growth-sm.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/growth-sm.mono.svg'),
  ),
  'guidance.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/guidance.colour.svg'),
  ),
  'guidance.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/guidance.mono.svg'),
  ),
  'helping-lg.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/helping-lg.colour.svg'),
  ),
  'helping-lg.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/helping-lg.mono.svg'),
  ),
  'helping-sm.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/helping-sm.colour.svg'),
  ),
  'helping-sm.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/helping-sm.mono.svg'),
  ),
  'high-five.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/high-five.colour.svg'),
  ),
  'high-five.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/high-five.mono.svg'),
  ),
  'home-delivery.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/home-delivery.colour.svg'),
  ),
  'home-delivery.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/home-delivery.mono.svg'),
  ),
  'how-to-use-it.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/how-to-use-it.colour.svg'),
  ),
  'how-to-use-it.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/how-to-use-it.mono.svg'),
  ),
  'human-emotions.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/human-emotions.colour.svg'),
  ),
  'human-emotions.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/human-emotions.mono.svg'),
  ),
  'ice-cream-fail.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/ice-cream-fail.colour.svg'),
  ),
  'ice-cream-fail.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/ice-cream-fail.mono.svg'),
  ),
  'idea.colour.svg': resolveAssetModule(require('../../../assets/illustrations/idea.colour.svg')),
  'idea.mono.svg': resolveAssetModule(require('../../../assets/illustrations/idea.mono.svg')),
  'juggle.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/juggle.colour.svg'),
  ),
  'juggle.mono.svg': resolveAssetModule(require('../../../assets/illustrations/juggle.mono.svg')),
  'living-room.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/living-room.colour.svg'),
  ),
  'living-room.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/living-room.mono.svg'),
  ),
  'looking-ahead-lg.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/looking-ahead-lg.colour.svg'),
  ),
  'looking-ahead-lg.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/looking-ahead-lg.mono.svg'),
  ),
  'looking-ahead-sm.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/looking-ahead-sm.colour.svg'),
  ),
  'looking-ahead-sm.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/looking-ahead-sm.mono.svg'),
  ),
  'man-thumbs-up.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/man-thumbs-up.colour.svg'),
  ),
  'man-thumbs-up.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/man-thumbs-up.mono.svg'),
  ),
  'man-waving.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/man-waving.colour.svg'),
  ),
  'man-waving.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/man-waving.mono.svg'),
  ),
  'map.colour.svg': resolveAssetModule(require('../../../assets/illustrations/map.colour.svg')),
  'map.mono.svg': resolveAssetModule(require('../../../assets/illustrations/map.mono.svg')),
  'meditation.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/meditation.colour.svg'),
  ),
  'meditation.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/meditation.mono.svg'),
  ),
  'member-taking-medication-alcohol.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/member-taking-medication-alcohol.colour.svg'),
  ),
  'member-taking-medication-alcohol.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/member-taking-medication-alcohol.mono.svg'),
  ),
  'member-taking-medication-tobacco.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/member-taking-medication-tobacco.colour.svg'),
  ),
  'member-taking-medication-tobacco.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/member-taking-medication-tobacco.mono.svg'),
  ),
  'member-taking-urine-test.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/member-taking-urine-test.colour.svg'),
  ),
  'member-taking-urine-test.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/member-taking-urine-test.mono.svg'),
  ),
  'member-using-app-blue.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/member-using-app-blue.colour.svg'),
  ),
  'member-using-app.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/member-using-app.colour.svg'),
  ),
  'member-using-app.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/member-using-app.mono.svg'),
  ),
  'mindfulness-activities-relaxing.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/mindfulness-activities-relaxing.colour.svg'),
  ),
  'mindfulness-activities-relaxing.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/mindfulness-activities-relaxing.mono.svg'),
  ),
  'nature-landscape.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/nature-landscape.colour.svg'),
  ),
  'nature-landscape.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/nature-landscape.mono.svg'),
  ),
  'nature-relaxation.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/nature-relaxation.colour.svg'),
  ),
  'nature-relaxation.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/nature-relaxation.mono.svg'),
  ),
  'negative-thoughts.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/negative-thoughts.colour.svg'),
  ),
  'negative-thoughts.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/negative-thoughts.mono.svg'),
  ),
  'notifications.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/notifications.colour.svg'),
  ),
  'notifications.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/notifications.mono.svg'),
  ),
  'office-space.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/office-space.colour.svg'),
  ),
  'office-space.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/office-space.mono.svg'),
  ),
  'overcoming-obstacles.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/overcoming-obstacles.colour.svg'),
  ),
  'overcoming-obstacles.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/overcoming-obstacles.mono.svg'),
  ),
  'peaceful-butterfly.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/peaceful-butterfly.colour.svg'),
  ),
  'peaceful-butterfly.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/peaceful-butterfly.mono.svg'),
  ),
  'picking-fruit.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/picking-fruit.colour.svg'),
  ),
  'picking-fruit.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/picking-fruit.mono.svg'),
  ),
  'progress-wide.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/progress-wide.colour.svg'),
  ),
  'progress-wide.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/progress-wide.mono.svg'),
  ),
  'progress.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/progress.colour.svg'),
  ),
  'progress.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/progress.mono.svg'),
  ),
  'reading-book.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/reading-book.colour.svg'),
  ),
  'reading-book.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/reading-book.mono.svg'),
  ),
  'reading-card.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/reading-card.colour.svg'),
  ),
  'reading-card.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/reading-card.mono.svg'),
  ),
  'reading-map.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/reading-map.colour.svg'),
  ),
  'reading-map.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/reading-map.mono.svg'),
  ),
  'relapse.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/relapse.colour.svg'),
  ),
  'relapse.mono.svg': resolveAssetModule(require('../../../assets/illustrations/relapse.mono.svg')),
  'relationship-interaction.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/relationship-interaction.colour.svg'),
  ),
  'relationship-interaction.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/relationship-interaction.mono.svg'),
  ),
  'relaxing-together.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/relaxing-together.colour.svg'),
  ),
  'relaxing-together.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/relaxing-together.mono.svg'),
  ),
  'rowing.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/rowing.colour.svg'),
  ),
  'rowing.mono.svg': resolveAssetModule(require('../../../assets/illustrations/rowing.mono.svg')),
  'sailing-together-lg.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/sailing-together-lg.colour.svg'),
  ),
  'sailing-together-lg.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/sailing-together-lg.mono.svg'),
  ),
  'sailing-together-sm.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/sailing-together-sm.colour.svg'),
  ),
  'sailing-together-sm.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/sailing-together-sm.mono.svg'),
  ),
  'save-money.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/save-money.colour.svg'),
  ),
  'save-money.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/save-money.mono.svg'),
  ),
  'setting-goals-archery.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/setting-goals-archery.colour.svg'),
  ),
  'setting-goals-archery.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/setting-goals-archery.mono.svg'),
  ),
  'setting-goals-calendar.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/setting-goals-calendar.colour.svg'),
  ),
  'setting-goals-calendar.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/setting-goals-calendar.mono.svg'),
  ),
  'skipping.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/skipping.colour.svg'),
  ),
  'skipping.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/skipping.mono.svg'),
  ),
  'success.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/success.colour.svg'),
  ),
  'success.mono.svg': resolveAssetModule(require('../../../assets/illustrations/success.mono.svg')),
  'thinking.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/thinking.colour.svg'),
  ),
  'thinking.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/thinking.mono.svg'),
  ),
  'waking-up.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/waking-up.colour.svg'),
  ),
  'waking-up.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/waking-up.mono.svg'),
  ),
  'walking-bridge-lg.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/walking-bridge-lg.colour.svg'),
  ),
  'walking-bridge-lg.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/walking-bridge-lg.mono.svg'),
  ),
  'walking-bridge-sm.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/walking-bridge-sm.colour.svg'),
  ),
  'walking-bridge-sm.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/walking-bridge-sm.mono.svg'),
  ),
  'walking.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/walking.colour.svg'),
  ),
  'walking.mono.svg': resolveAssetModule(require('../../../assets/illustrations/walking.mono.svg')),
  'watering-plant.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/watering-plant.colour.svg'),
  ),
  'watering-plant.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/watering-plant.mono.svg'),
  ),
  'welcome.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/welcome.colour.svg'),
  ),
  'welcome.mono.svg': resolveAssetModule(require('../../../assets/illustrations/welcome.mono.svg')),
  'well-done.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/well-done.colour.svg'),
  ),
  'well-done.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/well-done.mono.svg'),
  ),
  'woman-thumbs-up-2.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/woman-thumbs-up-2.colour.svg'),
  ),
  'woman-thumbs-up-2.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/woman-thumbs-up-2.mono.svg'),
  ),
  'woman-thumbs-up.colour.svg': resolveAssetModule(
    require('../../../assets/illustrations/woman-thumbs-up.colour.svg'),
  ),
  'woman-thumbs-up.mono.svg': resolveAssetModule(
    require('../../../assets/illustrations/woman-thumbs-up.mono.svg'),
  ),
};
